import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import QRCode from 'qrcode.react';
import QrListTable from "../../components/Tables/QrListTable";
import withPermissions from "../../components/WithPermissions";
class QrGenerate extends React.Component {
  constructor(props) {
    super(props);
    this.qrRef = React.createRef();
    this.state = {
      url: '',
      qrCodes: [],
      service_id: '',
      branch_id: '',
      branches: [],
      isLoad: true,
      loading: false,
    }
  }
  async componentDidMount() {
    window.scrollTo(0, 0);
    this.getQrInfo();
    this.setState({ branches: await getBranches() })
  }
  getQrInfo = async () => {
    try {
      var user = JSON.parse(localStorage.getItem('user'));

      var url = `${process.env.REACT_APP_MAIN_URL}/customer/service/create/${user.service_id}/`;

      const response = await apiCall('business/settings/get-qr', 'get', null);

      this.setState({ qrCodes: response, service_id: user.service_id, url: url }, () => {
        this.setState({ isLoad: false })
      });

    } catch (e) {
      console.log(e);
      this.setState({ isLoad: false });
    }
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleGenerateQRCode = async () => {
    this.setState({ loading: true });
    await this.generateQRCodeDataURL();
    await this.getQrInfo();
    this.setState({ loading: false });
  }

  generateQRCodeDataURL = () => {
    return new Promise((resolve) => {
      const canvas = this.qrRef.current.querySelector('canvas');

      if (canvas) {
        const qrCode = canvas.toDataURL();
        this.setState({ qrCode }, async () => {
          await this.saveQRCodeToDB();
          resolve();
        });
      }
    });
  }
  saveQRCodeToDB = async () => {
    try {
      const { url, qrCode, branch_id } = this.state;
      const response = await apiCall('business/settings/qrcode-create', 'post', { url, qr_code: qrCode, branch_id: branch_id });
      mainHelper.toastMessage(response.status, response.message);
    } catch (error) {
      console.error('Error saving QR Code:', error);
    }
  }

  render() {

    const { url, qrCodes, loading, branches } = this.state;
    const { userPermissions } = this.props;
    const userHasNewBranchQrPermission = userPermissions.includes('new branch qr');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Qr kod Oluştur"
              Breadcrumb={[
                { name: "Ayarlar", navigate: "" },
                { name: "Qr Kod Oluştur", navigate: "" },
              ]}
            />

            <div className="row clearfix justify-content-center">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body text-center">
                    <h6>Qr kodu oluştur</h6>
                    <div className="col-lg-12 d-flex justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <small>Servicezone olarak, işletmenizin dijital dönüşümüne katkı sağlayacak yenilikçi
                            çözümler
                            sunmaya devam ediyoruz. QR kod teknolojisi, müşteri deneyimini iyileştirme ve işletme
                            operasyonlarınızı daha verimli hale getirme konusunda büyük bir potansiyele sahiptir.
                            İşletmenize özel QR kodlar oluşturarak, müşterilerinizin servis kayıtlarını hızlı ve kolay
                            bir şekilde oluşturmasını sağlayabilirsiniz. </small>
                        </div>
                        <div className="form-group">
                          <div className="form-group">
                            <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="branch_id" id='branch_id' className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id} value={branch.id}>{branch.name}</option>
                              )))}

                            </select>
                          </div>
                        </div>
                        {loading ? (
                          <button
                            className="btn btn-outline-primary btn-lg btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}
                          >
                            Lütfen Bekleyin... <ReactLoading type="spin" color="#268bd2" width={'24px'}
                              height={'24px'} />
                          </button>
                        ) : (
                          <button disabled={!userHasNewBranchQrPermission}
                            onClick={this.handleGenerateQRCode}
                            className="btn btn-outline-primary btn-lg btn-block"
                            type="submit"
                          >
                            QR Oluştur
                          </button>
                        )}
                        <div className="form-group">
                          <div className="d-none" ref={this.qrRef}>
                            {<QRCode value={url + this.state.branch_id} size={256} renderAs="canvas" />}
                          </div>

                        </div>

                      </div>
                    </div>
                    <div className="col-lg-12">
                      <QrListTable bodyData={qrCodes} fetchQrs={this.getQrInfo}></QrListTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(QrGenerate)));
